interface ValidatorsInterface {
  isValidEmail: (email: string) => boolean
  isEmpty: (value: unknown) => boolean
  isNumber: (value: unknown) => boolean
  minLength: (value: string, length: number) => boolean
  maxLength: (value: string, length: number) => boolean
}

export const validators: ValidatorsInterface = {
  isValidEmail: (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  },

  isEmpty: (value: unknown) => {
    return (
      value === null ||
      value === undefined ||
      String(value).trim() === ''
    )
  },

  isNumber: (value: unknown) => {
    return !isNaN(Number(value)) && typeof Number(value) === 'number'
  },

  minLength: (value: string, length: number) => {
    return String(value).length >= length
  },

  maxLength: (value: string, length: number) => {
    return String(value).length <= length
  },
}

export default validators
